import { GameState } from "../consts/GameState";
import { GroundTypes } from "../consts/GroundTypes";
import { Game } from "../logic/Game";
import { Field } from "../models/Field";
import { Tower } from "../models/Tower";

export class GameUi {
    public selected_field: Field;

    constructor(
        public game: Game,
        public canvas: HTMLCanvasElement,
    ) {
        this.selected_field = game.map.at(5, 5);
        canvas.addEventListener("click", this.on_click);
    }

    public on_click = (event: MouseEvent) => {
        const x = (event.clientX - this.canvas.offsetLeft) * this.canvas.width / this.canvas.clientWidth;
        const y = (event.clientY - this.canvas.offsetTop) * this.canvas.height / this.canvas.clientHeight;
        if (x < 160 && x > 0 && y < 160 && y > 0) {
            const field_x = Math.floor(x * this.game.map.width / 160);
            const field_y = Math.floor(y * this.game.map.height / 160);
            this.select_field(field_x, field_y);
            this.build_tower();
        }
    }

    public select_field(x: number, y: number) {
        if (this.game.state !== GameState.PLAYING) return;
        this.selected_field = this.game.map.at(x, y);
    }

    public build_tower() {
        if (this.game.state !== GameState.PLAYING) return;
        const cost = 20 * this.game.tower_cost_multiplier;
        if (this.game.money < 20) return;
        if (this.selected_field.ground !== GroundTypes.GRAS) return;
        if (this.selected_field.tower !== null) return;
        this.game.money -= 20;
        this.game.tower_cost_multiplier *= 1.1;
        this.selected_field.tower = new Tower();
    }
}